export default (arr, keyCreator) =>
  arr.reduce((acc, item) => {
    const key = keyCreator(item);
    if (acc[key]) {
      acc[key].push(item);
    } else {
      acc[key] = [item];
    }
    return acc;
  }, {});



// WEBPACK FOOTER //
// ./src/store/contentfulRedux/helpers/groupBy.js